import { makeStyles, Typography, useTheme } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
  },
  title: {
    fontWeight: "500",
    marginBottom: 3,
  },
  line: {
    marginBottom: 9,
    height: 3,
    width: 50,
    backgroundColor: theme.palette.warning.main,
  },
}));

export default function ContentTitle(props) {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <div>
      <Typography
        variant="h6"
        style={{ color: theme.palette.darkIndigo.main, ...props.subTitleStyle }}
      >
        {props.subTitle}
      </Typography>
      {props.title && (
        <Typography
          variant="h4"
          color="secondary"
          className={classes.title}
          style={props.titleStyle}
        >
          {props.title}
        </Typography>
      )}
      {!props.hideLine && <div className={classes.line} />}
    </div>
  );
}
